import { Minus, Plus } from "lucide-react";

const CartAmountToggle = ({ quantity, setDecrease, setIncrease }) => {
  return (
    <div className="flex items-center justify-center gap-2">
      <button
        type="button"
        onClick={setDecrease}
        disabled={quantity === 1}
        className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-gray-300 text-gray-700 transition hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
        aria-label="Decrease quantity"
      >
        <Minus size={16} />
      </button>
      <span className="min-w-6 text-center font-medium">{quantity}</span>
      <button
        type="button"
        onClick={setIncrease}
        className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-gray-300 text-gray-700 transition hover:bg-gray-100"
        aria-label="Increase quantity"
      >
        <Plus size={16} />
      </button>
    </div>
  );
};

export default CartAmountToggle;
